import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import SourceFlowForm from '@sourceflow-uk/sourceflowform';
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import styles from './styles.module.scss';
import imageMetaData from "../../.sourceflow/image_metadata.json";

export default function SimpleFormWithBgImage({
    global,
    pathPrefix,
    customClass = "",
    formId,
    successPageUrl,
    bgImageLink,
    bgImageAlt,
    content,
    anchorID
}) {

    return (
        <>
            <div className={`${styles.root} ${customClass}`}>
                {anchorID && (
                    <div id={`${anchorID}`}></div>
                )}
                <span className="overlayBg position-absolute">
                    <img src={"/site-assets/svg/branded-logo.svg"} alt="Branded Logo" />
                </span>
                {bgImageLink ?
                    <SourceFlowImage
                        src={bgImageLink}
                        size="1000x1000"
                        alt={bgImageAlt}
                        className="card-img position-absolute"
                        imagesMetaData={imageMetaData}
                        path={pathPrefix ? pathPrefix : (`${pathPrefix}.image`) }
                    /> : null}
                <Container className="position-relative">
                    <Row>
                        <Col md={6} className="pe-md-5 mb-4 mb-md-0">
                            {content ?
                                <SourceFlowText global={global} path={`${pathPrefix}.content`} type="html">
                                    {content}
                                </SourceFlowText> : null}
                        </Col>
                        <Col md={6} className="ps-md-5 ">
                            {formId ?
                                <div className="p-5 bg-white rounded-4 formWrapper">
                                    <SourceFlowForm
                                        formId={formId}
                                        onSubmitDone={() => window.location.href = successPageUrl}
                                    />
                                </div> : ""}
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}